import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'

const Spinner = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1,
        background: 'white',
      }}
    >
      <CircularProgress />
    </Box>
  )
}
export default Spinner
